import { Link } from '@tanstack/react-router';

import { Button } from '@/components/ui/button';

/** Global 404 component (spec §4.2). */
export function NotFound() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 p-12 text-center">
      <h1 className="text-xl font-semibold">Page not found</h1>
      <p className="text-sm text-muted-foreground">
        The page you are looking for does not exist.
      </p>
      <Button render={<Link to="/">Back to home</Link>} />
    </div>
  );
}
